var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sfs-form-modal',{attrs:{"id":_vm.modalId,"title":"Edit Walkthrough"},on:{"on-hide":_vm.resetFormData}},[_c('walkthroughs-form',_vm._b({key:_vm.formKey,on:{"on-submit":_vm.updateWalkthrough,"on-save":_vm.onSave,"on-cancel":_vm.closeModal}},'walkthroughs-form',_vm.value,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }